import { UnparsedView } from '@paragon/contract-library';

import { JobFilter } from '../store/viewsSlice';
import { parseView, stringifyJobFilters, stringifyVisibleColumns } from '../viewUtilities';
import { SealingService } from './connections';

export async function pFetchAllForUser() {
  const unparsedViews: readonly UnparsedView[] = await SealingService.get('jobFilters');
  return unparsedViews.map((unparsedView) => parseView(unparsedView));
}

export async function pInsert(
  userEmail: string,
  name: string | null,
  jobFilters: readonly JobFilter[],
  visibleColumns: readonly string[],
) {
  const unparsedView: UnparsedView = await SealingService.post('jobFilters', {
    data: {
      UserEmail: userEmail,
      Name: name,
      Filter: stringifyJobFilters(jobFilters),
      Columns: stringifyVisibleColumns(visibleColumns),
    },
  });
  return parseView(unparsedView);
}

export async function pOverwrite(
  id: number,
  name: string,
  jobFilters: readonly JobFilter[],
  visibleColumns: readonly string[],
) {
  const unparsedView: UnparsedView = await SealingService.patch(`jobFilters/overwrite`, {
    data: {
      Id: id,
      Name: name,
      Filter: stringifyJobFilters(jobFilters),
      Columns: stringifyVisibleColumns(visibleColumns),
    },
  });
  return parseView(unparsedView);
}

export async function pDelete(jobFilterId: number) {
  const unparsedView: UnparsedView = await SealingService.delete(`jobFilters/${jobFilterId}`);
  return parseView(unparsedView);
}

export async function pSetDefault(jobFilterId: number) {
  const unparsedView: UnparsedView = await SealingService.post(`jobFilters/${jobFilterId}/SetDefault`);
  return parseView(unparsedView);
}

export function pRemoveDefault(): Promise<void> {
  return SealingService.post('jobFilters/RemoveDefault');
}
